// 全局 agents 信号 + 5 秒轮询。
//
// Day-4 阶段用 REST 轮询；
// Day-6 起 WS 帧 agent_offline / agent_online 即时打补丁，REST 仍兜底（每 15s 一次）。

import { signal } from "@preact/signals";
import type { AgentStatus } from "../transport/api";
import { api } from "../transport/api";

export const agents = signal<AgentStatus[]>([]);
export const agentsLoading = signal<boolean>(false);
export const agentsError = signal<string | null>(null);
export const agentsLastFetch = signal<number>(0);

/** WS 收到 agent_offline 时调（payload.agent_id） */
export function markAgentOffline(agentId: string) {
  agents.value = agents.value.map((a) =>
    a.id === agentId ? { ...a, online: false } : a
  );
}

/** WS 收到 agent_online 时调 */
export function markAgentOnline(agentId: string) {
  agents.value = agents.value.map((a) =>
    a.id === agentId ? { ...a, online: true } : a
  );
  // 顺便强 refresh 拿到 uptime / version 最新值
  void fetchAgentsOnce();
}

let pollTimer: number | null = null;

export async function fetchAgentsOnce() {
  agentsLoading.value = true;
  try {
    const resp = await api.listAgents();
    agents.value = resp.agents;
    agentsLastFetch.value = resp.server_ts;
    agentsError.value = null;
  } catch (e) {
    agentsError.value = (e as Error).message ?? String(e);
  } finally {
    agentsLoading.value = false;
  }
}

export function startAgentsPolling(intervalMs = 5000) {
  stopAgentsPolling();
  void fetchAgentsOnce();
  pollTimer = window.setInterval(() => {
    void fetchAgentsOnce();
  }, intervalMs);
}

export function stopAgentsPolling() {
  if (pollTimer) {
    clearInterval(pollTimer);
    pollTimer = null;
  }
}
